import { Badge, cn } from '@seen/ui'
import { IconChevronDown } from '@tabler/icons-react'
import React from 'react'
import { statusToColor } from '#src/components/display/constants.ts'

export const StatusBadge = React.forwardRef<
  HTMLDivElement,
  {
    status: string
    label?: string
    onClick?: (event: React.MouseEvent) => void
  }
>(({ status, label, onClick }, ref) => (
  <div
    ref={ref}
    className={cn('inline-flex items-center', onClick && 'cursor-pointer')}
    onClick={onClick}
  >
    <Badge
      color={statusToColor[status] as any}
      className="uppercase"
      variant="outline"
    >
      {label ?? status}
      {onClick && <IconChevronDown size={12} className="ml-1" />}
    </Badge>
  </div>
))
StatusBadge.displayName = 'StatusBadge'
